// extracted by mini-css-extract-plugin
module.exports = {"container":"FantasyBanner_container__1oXdU","fancy":"FantasyBanner_fancy__2h7G2","button":"FantasyBanner_button__1holc"};